export default {
  header: 'Remove Design',
  buttonText: 'Remove This Design',
  content: 'This design will be removed. If you remove this design, you may lose your changes.',
};

